<template>
  <s-popper
    class="nav-item d-flex"
    placement="bottom-start"
    tag="li"
    v-if="showDevelopmentMode"
  >
    <a class="navbar-nav-link dropdown-toggle p-0" href="#">
      <div class="d-flex align-items-center py-1 px-1 navbar-nav-link--hover">
        <settings-icon class="icon--mini"/>
        <dropdown-icon class="ml-1" style="width: 9px; height: 9px;"/>
      </div>
    </a>

    <template #popup>
      <div class="dropdown-menu navbar-create-dropdown p-0">
        <span class="border-bottom d-block p-2 font-weight-midbold p-1">DEV settings</span>
        <div class="nav-item nav-item-submenu rounded-0 p-1">
          <a @click.prevent="toggleDevMode('translations')" class="dropdown-item">
            <div class="d-flex d-gap-10">
              <i>
                <eye-icon/>
              </i>
              <span>Translations preview:
                <span class="font-weight-bold" :class="[previewModeStatus('translations') ? 'text-success' : 'text-danger']">
                  {{ previewModeStatus('translations') ? 'On' : 'Off' }}
                </span>
              </span>
            </div>
          </a>
          <a @click.prevent="toggleDevMode('feature_flags')" class="dropdown-item">
            <div class="d-flex d-gap-10">
              <i>
                <unlock-icon/>
              </i>
              <span>Features flags:
                <span class="font-weight-bold" :class="[previewModeStatus('feature_flags') ? 'text-success' : 'text-danger']">
                  {{ previewModeStatus('feature_flags') ? 'On' : 'Off' }}
                </span>
              </span>
            </div>
          </a>
          <s-popper
            class="nav-item dropdown-item"
            placement="left"
            tag="li"
          >
            <a href="#" class="text-black">
              <div class="d-flex d-gap-10">
                <i>
                  <user-icon/>
                </i>
                <span>Change Subscription</span>
              </div>
            </a>

            <template #popup>
              <div class="dropdown-menu">
                <a @click.prevent="toggleDevMode('change_subscription', 'mini')" class="dropdown-item">
                  <div class="d-flex d-gap-10">
                    <span>Mini</span>
                  </div>
                </a>
                <a @click.prevent="toggleDevMode('change_subscription', 'single')" class="dropdown-item">
                  <div class="d-flex d-gap-10">
                    <span>Single</span>
                  </div>
                </a>
                <a @click.prevent="toggleDevMode('change_subscription', 'business')" class="dropdown-item">
                  <div class="d-flex d-gap-10">
                    <span>Business</span>
                  </div>
                </a>
                <a @click.prevent="toggleDevMode('change_subscription', 'free')" class="dropdown-item">
                  <div class="d-flex d-gap-10">
                    <span>Free</span>
                  </div>
                </a>
              </div>
            </template>
          </s-popper>
          <div @click="showPersonalizationModal" class="dropdown-item">
            <div class="d-flex d-gap-10">
              <i>
                <database-icon/>
              </i>
              <span>Show personalization</span>
            </div>
          </div>

          <div @click="resetPersonalizationGuide" class="dropdown-item">
            <div class="d-flex d-gap-10">
              <i>
                <database-icon/>
              </i>
              <span>Reset personalization guide</span>
            </div>
          </div>
          <a @click.prevent="toggleDevMode('clear_all')" class="dropdown-item">
            <div class="d-flex d-gap-10">
              <i>
                <delete-icon/>
              </i>
              <span>Clear all</span>
            </div>
          </a>
        </div>
      </div>
    </template>
  </s-popper>
</template>

<script setup>
  import EyeIcon from '@/components/icons/eye.vue';
  import UnlockIcon from '@/components/icons/unlock.vue';
  import DeleteIcon from '@/components/icons/delete.vue';
  import SettingsIcon from '@/components/icons/settings.vue';
  import DropdownIcon from '@/components/icons/dropdown.vue';
  import { computed } from 'vue';
  import { httpService } from '@/core';
  import { userDevModePreviewUrl } from '@/api/auth';
  import { useAuthStore } from '@/stores/auth.ts';
  import UserIcon from '@/components/icons/user.vue';
  import DatabaseIcon from '@/components/icons/database.vue';

  const authStore = useAuthStore();
  const showDevelopmentMode = computed(() => process.env.ENVIRONMENT_STATUS !== 'production');

  async function toggleDevMode(type, value) {
    httpService.post(userDevModePreviewUrl(), {
      data: { type: type, value: value },
    })
      .then(() => window.location.reload());
  }

  function previewModeStatus(type) {
    if (!showDevelopmentMode.value) {
      return null;
    }

    return authStore.previewModes?.[type];
  }

  async function showPersonalizationModal() {
    const showPersonalization = localStorage.getItem('showPersonalization');

    await new Promise((resolve) => {
      if (!showPersonalization || showPersonalization === 'false') {
        localStorage.setItem('showPersonalization', 'true');
      } else {
        localStorage.setItem('showPersonalization', 'false');
      }
      resolve();
    });

    window.location.reload();
  }

  async function resetPersonalizationGuide() {
    httpService.patch('/rest/onboarding-guide/reset')
      .then(() => {
        window.location.reload();
      });
  }
</script>
